export const matchAllPairs = <ARG, RETURN = ARG>(
  callback: (el1: ARG, el2: ARG) => RETURN,
  elements1: ARG[],
  elements2: ARG[],
): RETURN[] =>
  elements1.reduce<RETURN[]>(
    (acc, element1) => [
      ...acc,
      ...elements2.map((element2) => callback(element1, element2)),
    ],
    [],
  )
